import React from "react";

const NotFound = () => {
  return (
    <div className="text-center pt-2" style={{ color: "#2f3778" }}>
      <h1>Not Found</h1>
    </div>
  );
};

export default NotFound;
